// Onde a jornada do cliente vem: mock local ou HTTP.
//
// NOTA: Este é o SEAM da entrega. Enquanto o backend não publica
// /v3/api/client-journey, tudo roda sobre `mocks/`. Quando publicar, muda-se
// DEFAULT_SOURCE para 'http' — uma linha — e nenhum componente é tocado, porque
// nenhum componente conhece este arquivo: passam por `journey-service`.
//
// Espelha o padrão de `@modules/navegacao-v2/utils/nav2026-enabled`: default no
// código, override por localStorage para conseguir testar a outra ponta sem
// deploy.
export const JOURNEY_SOURCE_KEY = 'client-journey:source'
export const SOURCE_MOCK = 'mock'
export const SOURCE_HTTP = 'http'

export const DEFAULT_SOURCE = SOURCE_MOCK

export function sourceAtual() {
  try {
    const override = globalThis.localStorage.getItem(JOURNEY_SOURCE_KEY)
    if (override === SOURCE_MOCK || override === SOURCE_HTTP) return override
  } catch {
    // Storage indisponível (aba privada, storage bloqueado): cai no default.
    // Perder o override é aceitável; quebrar a tela por isso não é.
  }
  return DEFAULT_SOURCE
}

export function isMockSource() {
  return sourceAtual() === SOURCE_MOCK
}
